export const ELECTIONTYPE_COUNCIL = 2;

export const filterByCity = (item, city) => !city || item.city === city.id;
export const filterByDistrict = (item, district) => !district || item.district === district.id;
export const filterByCityAndElectiontypeCouncil = (item, city) => item.city === city.id && item.type === ELECTIONTYPE_COUNCIL;
export const filterByDistrictAndElectiontypeCouncil = (item, district) => (!district || item.district === district.id) && item.type === ELECTIONTYPE_COUNCIL;
